const TradingStore = function() {
  this.state = {
    layout: {
      hideleft: false
    },
    token: '',
    route: {
      name: 'ReceivedInquiry',
      params: {}
    }
  };
};

TradingStore.prototype.mutations = {
  setLayout(state, layout) {
    state.layout = Object.assign({}, state.layout, layout);
  },
  setToken(state, token) {
    state.token = token;
  },
  setRoute(state, route) {
    state.route = route;
  }
};

TradingStore.prototype.commit = function(name, ...args) {
  const mutations = this.mutations;
  if (mutations[name]) {
    mutations[name].apply(this, [this.state].concat(args));
  } else {
    throw new Error(`Action not found: ${name}`);
  }
};
const store = new TradingStore();
export default store;
